import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import ReviewForm from './ReviewForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';


class NewReviewModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
            initialValues: {
                userid: this.props.product.userid,
                author_name: this.props.product.author.displayName,
            },
        };
    }
    submitHandler = ( values ) => {
        var data = { ...values };
        data.userid = data.userid ? data.userid : this.props.product.userid;
        data.desireid = this.props.product.desireid;
        this.setState( { fetching: true } );
        this.props.createReview( data )
        .then( ( review ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( review );
        } );
    }



    render() {
        return (
            <DLModal title='New Review'
            closeHandler={ this.props.closeModal }>
                <div>
                    <ReviewForm next={ this.submitHandler } initialValues={ this.state.initialValues } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        createReview: ( data ) => {
            return dAPI.post( '/admin/reviews', data );
        },
    };
};

export default connect( null, mapDispatchToProps )( NewReviewModal );
